module.exports = __webpack_public_path__ + "static/media/engage-design3.d9084141.png";